jQuery3_4_1(document).ready(function($){
    class Compass { 
        constructor(parent) {
            const self = this;
            if(parent.compass){
                return;
            }
            parent.compass = this; 
            self.parent = $(parent);
            self.awake();
            setTimeout(function(){
                self.start();
            },0);
        }

        awake(){
            const self = this;
            self.emitter = new DDEmitter();
            self.currentAngle = self.parent.data("direction");
            self.icon = self.parent.find(".dd-compass-background");
        }

        start(){
            const self = this;
            self.rotateIcon(self.currentAngle);
        }

        animateTo(angle, direction){
            const self = this;
            angle = angle % 360;
            angle = angle < 0 ? angle + 360 : angle;
            let normalCurrentAngle = self.currentAngle % 360;
            normalCurrentAngle = normalCurrentAngle < 0 ? normalCurrentAngle + 360 : normalCurrentAngle;
            let turn = 0;
            if(direction > 0) {
                // console.log("Forwards from:", normalCurrentAngle, "to", angle );
                turn = angle - normalCurrentAngle;
                if(normalCurrentAngle > angle){
                    // console.log("Impossible, must go an ekstra round to:", angle + 360);
                    turn += 360;
                }
            } else {
                // console.log("Backwards from:", normalCurrentAngle, "to", angle );
                turn = angle - normalCurrentAngle;
                if(normalCurrentAngle < angle){
                    // console.log("Impossible, must go an ekstra round to:", angle - 360);
                    turn -= 360;
                }
            }
            if(normalCurrentAngle == angle) {
                // console.log("It's the same. Abort.");
                return;
            }
            const targetAngle = self.currentAngle + turn;
            // console.log("Should turn:", turn, "from current:", self.currentAngle, "resulting in:", targetAngle);
            self.rotateIcon(targetAngle);
        }

        rotateIcon(angle){
            const self = this;
            self.icon.css("transform", "rotate("+angle+"deg)");
            self.currentAngle = angle;
        }


        // EVENT EMITTER
        on(eventName, callback) {  // Available events: start, end   // CHANGE HERE
            const self = this;
            self.emitter.on(eventName, callback);
        }

        off(eventName, callback) {
            const self = this;
            self.emitter.off(eventName, callback);
        }
    }

    class DDEmitter {
        constructor(){
            this.events = {};
        }
    
        on(eventName, callback) {
            const self = this;
            if (!self.events[eventName]) {
                self.events[eventName] = [];
            }
            self.events[eventName].push(callback);
        }
    
        off(eventName, callback) {
            const self = this;
            const eventHandlers = self.events[eventName];
            if (eventHandlers) {
                self.events[eventName] = eventHandlers.filter(fn => fn !== callback);
            }
        }
    
        emit(eventName, ...args) {
            const self = this;
            const eventHandlers = self.events[eventName];
            if (eventHandlers) {
                eventHandlers.forEach(callback => {
                    callback(...args);
                });
            }
        }
    }

    registerOnLoadEvent(function(){
        $(".dd-compass").each(function(){ 
            new Compass(this);
        })
    })
});
  